
import $ from 'jquery';
import 'flexslider';

const SLIDER_REENABLE_INTERVAL = 6000;

export default class Slider {
    /**
     * Create new slider instance
     *
     * @param {import('../ThemeBase').default} theme
     * @param {HTMLElement} element
     */
    constructor(theme, element) {
        this.theme = theme;
        this.element = element;
        this.$element = $(element);
        this.restartTimer = null;
        this.forcePause = false;

        // Prevent flickering in the flexslider by setting fixed width of the slides
        this.$element.find('.slides li').css('width', this.$element.width());

        this.flexslider = this.configure({});

        // flexslider stops the animation when the page is not focused, this breaks when the section is
        // changed in theme admin because it triggers 'blur' event when another iframe is selected
        $(window).off('blur');
    }

    getSpeed = () => {
        return parseInt(this.$element.data('sliderSlideTime'));
    };

    getId = () => {
        return this.$element.data('sliderId');
    };

    getSmoothHeightState = () => {
        return $(window).width() < 767;
    };

    getAnimation = () => {
        return this.$element.data('sliderAnimation');
    };

    getDots = () => {
        return this.$element.data('sliderDots');
    };

    getArrows = () => {
        return this.$element.data('sliderArrows');
    };

    currentSlide = () => {
        return this.$element.find('.flex-active-slide').data('slide-index');
    }

    showSlide = (index) => {
        if (this.getSpeed() > 0) {
            this.flexslider.pause();
            this.forcePause = true;
        }
        if (this.currentSlide() !== index) {
            // Change slide without animation
            this.flexslider.flexAnimate(index);
            //this.flexslider.wrapup($(window).width());
        }
    };

    startAnimation = () => {
        // Don't start animation when autorotate is disabled
        this.forcePause = false;
        if (this.getSpeed() > 0) {
            this.flexslider.play();
        }
    };

    onSlideChange = (slider) => {
        var speed = this.getSpeed();
        if (!this.forcePause && !slider.playing && speed > 0) {
            // restart autoscroll after given interval since last interaction
            clearTimeout(this.restartTimer);
            this.restartTimer = setTimeout(function () {
                slider.play();
            }, Math.max(0, SLIDER_REENABLE_INTERVAL - speed));
        }
    };

    configure = (options) => {
        if ($(window).width() === 0) {
            // the app is not yet loaded in the admin, retry later
            setTimeout(this.configure.bind(this), 200);
            return;
        }
        var speed = this.getSpeed();
        var id = this.getId();
        var numSlides = this.$element.find('ul.slides li').length;

        var opts = $.extend(
            {
                directionNav: this.getArrows(),
                controlNav: this.getDots(),
                startAt: 0,
                slideshowSpeed: speed,
                animation: this.getAnimation(),
                controlsContainer: $('.slider-pagination-container.slider--'+id),
                customDirectionNav: $('.flex-direction-nav.slider--'+id+' a'),
                slideshow: (speed > 0 && numSlides > 1),
                touch: numSlides > 1,
                pauseOnAction: true,
                after: this.onSlideChange.bind(this)
            },
            options,
        );

        if ($('.slider-pagination-container.slider--'+id).length === 0){
            options.controlNav = false;
        } else {
            options.controlNav = true;
        }

        if($('.flex-direction-nav.slider--'+id+' a').length === 0){
            options.directionNav = false;
        } else {
            options.directionNav = true;
        }

        this.$element.find('ul.slides').width('auto');
        return this.$element.flexslider(opts).data('flexslider');
    };
}
